import styled from '@emotion/styled'

export const MapStyled = styled.div`
  margin-top: 20px;
  box-shadow: 0 0 2px var(--foreground);
  border-radius: 25px;
  overflow: hidden;
`
